<template>
  <div class="issue">
    <Ordervue :order="order" :total="total"></Ordervue>
    <div style="width:calc(100% - 50px)">
      <div class="singlechoice">
        <div class="title">
          <span v-html="message.question"></span>
          <span class="titlehou">
            （{{message.questionscore}}分）
            <span class="type">{{message.questiontype|type}}</span>
          </span>
        </div>
        <div class="choice" v-if="message.questiontype==1">
          <RadioGroup v-model="value" @on-change="sure" vertical>
            <div
              :class="{item:true,act:value==key}"
              v-for="(item,key) in message.questionselect"
              :key="key"
            >
              <Radio :disabled="disabled" :label="key">
                <span>{{key}}.</span>
              </Radio>
              <span v-html="item.txt"></span>
            </div>
          </RadioGroup>
        </div>
        <div class="choice" v-if="message.questiontype==2">
          <CheckboxGroup v-model="value" @on-change="sure">
            <div
              :class="{item:true,act:check(key)}"
              v-for="(item,key) in message.questionselect"
              :key="key"
            >
              <Checkbox :disabled="disabled" :label="key" style="width:70px;">
                <span>{{key}}.</span>
              </Checkbox>
              <span v-html="item.txt"></span>
            </div>
          </CheckboxGroup>
        </div>
        <div class="choice" v-if="message.questiontype==4">
          <i-input
            type="text"
            @on-change="sure"
            v-model="value"
            :disabled="disabled"
            style="width:100%"
            placeholder="请输入填空题答案，多个答案请用','分割"
          ></i-input>
        </div>
        <div class="choice" v-if="message.questiontype==3">
          <RadioGroup v-model="value" @on-change="sure">
            <div
              :class="{item:true,act:value==key}"
              v-for="(item,key) in message.questionselect"
              :key="key"
            >
              <Radio :disabled="disabled" :label="key">
                <span>{{key}}.</span>
              </Radio>
              <span v-html="item.txt"></span>
            </div>
          </RadioGroup>
        </div>
        <div class="choice" v-if="message.questiontype==5">
          <i-input
            type="textarea"
            @on-change="sure"
            v-model="value"
            :disabled="disabled"
            style="width:100%"
            placeholder="请输入您得答案"
          ></i-input>
        </div>
      </div>
      <div class="asw" v-if="showasw&&(message.questiontype!=0)">
        正确答案：
        <span class="right">{{message.usermes.questionanswer}}</span> 你的答案：
        <span class="error">{{message.usermes.esuseranswer}}</span>
        得分：{{message.usermes.esscore}}分
      </div>
    </div>
  </div>
</template>
<script>
import Ordervue from "@/components/issue/order";
export default {
  name: "issue",
  data() {
    return {
      value: (() => {
        if (this.message.questiontype == 2) {
          if(this.message.questionanswer){
            return this.message.questionanswer.split(",");
          }else{
            return []
          }
        }
        return this.message.questionanswer;
      })()
    };
  },
  props: ["message", "showasw", "order", "total", "disabled"],
  components: { Ordervue },
  filters: {
    type(value) {
      return ["说明", "单选题", "多选题", "判断题", "填空题", "问答题"][value];
    }
  },
  methods: {
    check(data) {
      if (this.value) {
        if (this.value.indexOf(data) != -1) {
          return true;
        }
      }
      return false;
    },
    sure() {
      if (this.value && this.value.length > 2000) {
        this.$Notice.error({
          title: "错误提示",
          desc: "答案不能长于2000字符"
        });
        return;
      }
      var value = JSON.parse(JSON.stringify(this.value))
      if (this.message.questiontype == 2) {
       value = value.filter(item => item).sort().toString();
      } else {
        value = value.toString();
      }
      this.$emit("sure", {
        questionid: this.message.questionid,
        questionanswer: value
      });
    }
  }
};
</script>
<style lang="css" scoped>
.issue {
  display: flex;
  justify-content: flex-start;
  margin-top: 0.1rem;
}
.asw {
  text-align: right;
  font-size: 0.14rem;
  line-height: 0.3rem;
  color: #575e6b;
}
.asw span {
  margin-right: 0.1rem;
}
.asw .right {
  color: #1dd05c;
}
.asw .error {
  color: #ff1856;
}
/*具体题目样式*/
.singlechoice {
  /* margin-top: 0.3rem; */
  text-align: left;
  color: #2b2d31;
  line-height: 0.25rem;
  font-size: 0.14rem;
}
.choice {
  margin-top: 0.1rem;
}
.choice .item {
  color: #6c6d6e;
  font-size: 0.14rem;
  word-break: break-all;
  word-wrap: break-word;
  white-space: normal;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
}
.choice .item.act {
  color: #2b2d31;
}
.title {
  display: flex;
  justify-content: flex-start;
}
.titlehou {
  margin-left: 10px;
  width: 150px;
}
input {
  width: 2rem;
  height: 0.3rem;
  border-bottom: 1px solid #575e6b;
  background: transparent;
  color: #575e6b;
}
/*按钮颜色，针对不同的按钮显示不同的颜色*/
.type {
  display: inline-block;
  width: 0.6rem;
  height: 0.2rem;
  line-height: 0.18rem;
  font-size: 0.14rem;
  text-align: center;
  border-radius: 2px;
  border: 1px solid #ffb22c;
  background: #fff3dd;
  color: #ffb22c;
}
</style>


// WEBPACK FOOTER //
// src/components/issue.vue